import { FORM } from 'src/constants/Form';
import { t } from 'src/lib/language';
import FormMultipleSelect from 'src/components/Control/FormControls/FormMultipleSelect';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { INVOICE_PAYMENT_STATUS, INVOICE_PAYMENT_STATUS_LIST } from 'src/constants/Invoices';

interface Props {
  values: INVOICE_PAYMENT_STATUS[],
  onChange: (field: string, paymentStatus:any) => void
}
const InvoicePaymentStatusSelector = (props: Props) => {
  const { values, onChange } = props;

  const lang = useSelector((state: Store) => state.language.language);

  const getPaymentStatus = () => INVOICE_PAYMENT_STATUS_LIST
    .sort(
      (a, b) => a.toUpperCase().localeCompare(b.toUpperCase()),
    )
    .map((status: INVOICE_PAYMENT_STATUS) => ({
      label: status.toUpperCase(),
      id: status,
    }));

  return (
    <FormMultipleSelect
      form={FORM.admin_donation}
      name="paymentStatus"
      label={t(lang, 'forms.invoices.payment_status')}
      onChange={(status: string) => onChange('paymentStatus', status)}
      value={values}
      items={getPaymentStatus()}
      noMarginTop />
  );
};

export default InvoicePaymentStatusSelector;
